export const DEFAULT_LEADERBOARD_BANNER_SRC = "/Leaderboard_Amateur.png";

const loadedBannerSrcs = new Set([DEFAULT_LEADERBOARD_BANNER_SRC]);
const pendingBannerLoads = new Map();

export function preloadLeaderboardBanner(src) {
  const target = String(src || "").trim() || DEFAULT_LEADERBOARD_BANNER_SRC;

  if (loadedBannerSrcs.has(target)) {
    return Promise.resolve(target);
  }

  if (pendingBannerLoads.has(target)) {
    return pendingBannerLoads.get(target);
  }

  const promise = new Promise((resolve, reject) => {
    const image = new Image();
    image.decoding = "async";
    if ("fetchPriority" in image) {
      image.fetchPriority = "high";
    }

    image.onload = () => {
      loadedBannerSrcs.add(target);
      pendingBannerLoads.delete(target);
      resolve(target);
    };

    image.onerror = () => {
      pendingBannerLoads.delete(target);
      reject(new Error(`Failed to preload banner: ${target}`));
    };

    image.src = target;
  });

  pendingBannerLoads.set(target, promise);
  return promise;
}
